import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-delete-permiso',
  templateUrl: './dialog-delete-permiso.component.html',
  styleUrls: ['./dialog-delete-permiso.component.css']
})
export class DialogDeletePermisoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
